import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";

let accessToken = '';

class UnCommitTransactionPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;
    }

    render() {
        return (
            <div className="row" style={{ height: '100%', width: '100%' }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={this.props.previewData}
                    showBorders={true}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    width="100%"
                    height="100%"
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={100} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 100, 500, 1000, "all"]}
                        showNavigationButtons={true}
                        showInfo={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <Column dataField="recordNumber" caption="Record #" dataType="string"/>
                    <Column dataField="transactionNumber" caption="Transaction #" dataType="string" />
                    <Column dataField="transactionType" caption="Transaction Type" dataType="string" />
                    <Column dataField="transactionDate" caption="Transaction Date" dataType="datetime"  format="MM/dd/yyyy hh:mm:ss aa" />
                    <Column dataField="actualReceivedShippedDateTime" caption="Recv/Ship Date" dataType="datetime"  format="MM/dd/yyyy hh:mm:ss aa" />
                    <Column dataField="shipperBolNumber" caption="Shipper BOL #" dataType="string"/>
                    <Column dataField="reference" caption="PO/Reference #"  dataType="string"/>
                    <Column dataField="creationUserId" caption="Created By" dataType="string" />
                    <Column dataField="lastUpdateUserId" caption="Last Updated By"dataType="string"  />
                    <Column dataField="customerCode" caption="Customer" dataType="string" />
                    <Column dataField="customerName" caption="Customer Name" dataType="string" />
                    <Column dataField="department" caption="Department" dataType="string"  />
                    <Column dataField="batchNumber" caption="Batch #" dataType="string" />
                    <Column dataField="commitDate" caption="Commit Date" dataType="datetime"  format="MM/dd/yyyy hh:mm:ss aa"  />
                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UnCommitTransactionPreview);